import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

interface Bank {
  bank: string;
  accountId: string;
  accountType?: string;
  account?: string;
  accountNumber?: string;
  routingNumber?: string;
  currency?: string;
  mask?: string;
  plaidPublicToken?: string;
  iban?: string;
  owners?: string;
  tokenId?: string;
}

export function addBankAccount(account: Bank): Promise<any> {
  return fetchWrapper(endpoint + '/v1/bank-account', {
    method: 'post',
    body: JSON.stringify(account),
  }).then((res) => res.json());
}

export function refreshBankTokenConnection(bankAccountId): Promise<any> {
  return fetchWrapper(endpoint + `/v1/bank-account/${bankAccountId}`, {
    method: 'put',
    body: JSON.stringify({ action: 'refresh_token_connection' }),
  });
}
